var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { align: "left", justify: "center" } },
    [
      _c("Loading", {
        attrs: { active: _vm.loadingInicial, "is-full-page": true }
      }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _vm.mostrarBotaoFlutuante && _vm.selecionados.length !== 0
            ? _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    color: "green",
                                    fixed: "",
                                    right: "",
                                    bottom: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.modalEmail = true
                                    }
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { dark: "" } }, [
                                  _vm._v("download")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    959324881
                  )
                },
                [_c("span", [_vm._v("Baixar instrumentos")])]
              )
            : _vm._e(),
          _c(
            "v-card",
            { attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-sync ")]
                  ),
                  _vm._v("Títulos > Baixar Instrumentos de Protesto em Massa ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "mt-2 mb-3",
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.botaoFiltrar.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-row",
                { staticClass: "mx-6 mt-3 pt-3", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        xs: "12",
                        sm: "12",
                        md: "12",
                        lg: "8"
                      }
                    },
                    [
                      _c(
                        "v-card-text",
                        {
                          staticClass:
                            "text-left font-weight-black display-1 pl-0",
                          style: { color: _vm.primaryColorFont }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "ma-2", attrs: { large: "" } },
                            [_vm._v(" mdi-download-circle-outline ")]
                          ),
                          _vm._v("Baixar Instrumentos de Protesto em lote ")
                        ],
                        1
                      ),
                      _c("v-textarea", {
                        attrs: {
                          solo: "",
                          small: "",
                          label:
                            "Cole aqui os títulos que deseja solicitar o download de Instrumento de Protesto",
                          hint:
                            "Insira nesse campo todos os títulos que deseja buscar separando por virgula, por exemplo: 477977/1, 721603/6, 755202/5",
                          placeholder: "Exemplo:  477977/1, 721603/6, 755202/5",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtros.ds_nosso_numero,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "ds_nosso_numero", $$v)
                          },
                          expression: "filtros.ds_nosso_numero"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-2",
                      attrs: { cols: "12", sm: "12", md: "12", lg: "4" }
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12", lg: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "grey white--text white--text" },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "ma-2 text-left white--text" },
                                [_vm._v(" mdi-chevron-down ")]
                              ),
                              _vm._v("fazer upload de arquivo XLS ")
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "font-weight-light text-left title-1"
                            },
                            [
                              _vm._v(
                                " Utilize o campo abaixo para fazer upload de arquivo com os títulos em massa para downoad de Instrumentos de Protesto. Formatos compatíveis: .xls/.xlsx/.xlsm Limite de tamanho: 60mb "
                              )
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "grey white--text",
                              attrs: {
                                block: "",
                                plain: "",
                                small: "",
                                href: _vm.link_modelo
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "ma-2 text-left" }, [
                                _vm._v(" mdi-file-download ")
                              ]),
                              _vm._v("Baixar modelo ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-2",
                          attrs: { cols: "12", sm: "12" }
                        },
                        [
                          _c("v-file-input", {
                            ref: "myFileInput",
                            staticClass: "mb-n7 white--text",
                            attrs: {
                              accept:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx, .xlsm",
                              label: "Selecione o arquivo (.xls/.xlsx/.xlsm)",
                              "show-size": "",
                              chips: "",
                              solo: "",
                              id: "fileInput",
                              name: "file"
                            },
                            on: { change: _vm.uploadFileReference }
                          }),
                          _vm.fazendoUpload
                            ? _c(
                                "v-card-text",
                                {
                                  staticClass:
                                    "font-weight-light text-left title-1"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-1",
                                      attrs: {
                                        color: "green",
                                        "x-small": "",
                                        elevation: "0",
                                        fab: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "white--text" },
                                        [_vm._v("mdi-check")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " Títulos verificados: " +
                                      _vm._s(_vm.retornaDadosXls()) +
                                      " linhas"
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.fazendoUpload
                            ? _c(
                                "v-card-text",
                                { staticClass: "text-left title-1" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-1",
                                      attrs: {
                                        color: "green",
                                        "x-small": "",
                                        elevation: "0",
                                        fab: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "white--text" },
                                        [_vm._v("mdi-magnify")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" Para confirmar, clique em Filtrar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-expansion-panels",
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "grey lighten-4",
                                  attrs: { small: "" }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass:
                                        "font-weight-light black--text"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "primary--text lighten-2"
                                        },
                                        [_vm._v(" search ")]
                                      ),
                                      _vm._v(" Filtrar Resultados ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "my-3" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "4",
                                            xs: "2",
                                            sm: "2",
                                            md: "3",
                                            lg: "3"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              solo: "",
                                              small: "",
                                              label: "CPF/CNPJ",
                                              hint:
                                                "Informe o Número do CPF/CNPJ",
                                              placeholder: "Ex.:000.000.000-00",
                                              clearable: ""
                                            },
                                            model: {
                                              value:
                                                _vm.filtros
                                                  .nu_identificacao_devedor,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtros,
                                                  "nu_identificacao_devedor",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                filtros.nu_identificacao_devedor\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "5",
                                            xs: "2",
                                            sm: "2",
                                            md: "3",
                                            lg: "3"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              solo: "",
                                              small: "",
                                              label: "Nome",
                                              hint:
                                                "Informe o nome para efetuar a busca",
                                              placeholder: "Ex.: José",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.filtros.nm_devedor,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtros,
                                                  "nm_devedor",
                                                  $$v
                                                )
                                              },
                                              expression: "filtros.nm_devedor"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "10",
                                            xs: "2",
                                            sm: "2",
                                            md: "3",
                                            lg: "3"
                                          }
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              solo: "",
                                              small: "",
                                              items: _vm.listaUfs,
                                              label: "UF",
                                              "return-object": true
                                            },
                                            model: {
                                              value: _vm.filtros.cd_uf_devedor,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtros,
                                                  "cd_uf_devedor",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filtros.cd_uf_devedor"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mx-0 mt-2 mb-0 pa-0" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "pr-9",
                      attrs: {
                        cols: "10",
                        xs: "6",
                        sm: "6",
                        md: "3",
                        lg: "3",
                        align: "center"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: {
                            block: "",
                            color: "primary",
                            loading: _vm.loadingFiltros
                          },
                          on: { click: _vm.botaoFiltrar }
                        },
                        [
                          _vm._v(" Filtrar "),
                          _c("v-icon", { staticClass: "ml-2" }, [
                            _vm._v("search")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.modalEmail
            ? _c(
                "v-dialog",
                {
                  attrs: { "max-width": "500" },
                  model: {
                    value: _vm.modalEmail,
                    callback: function($$v) {
                      _vm.modalEmail = $$v
                    },
                    expression: "modalEmail"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "headline primary--text" },
                            [_vm._v("Instrumentos de Protesto via e-mail")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-form",
                            {
                              ref: "formEmail",
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.checarEmailValido()
                                }
                              },
                              model: {
                                value: _vm.emailValido,
                                callback: function($$v) {
                                  _vm.emailValido = $$v
                                },
                                expression: "emailValido"
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "prepend-icon": "person",
                                  name: "email",
                                  label: "E-mail",
                                  type: "email",
                                  rules: _vm.emailRegras,
                                  required: "",
                                  "data-cy": "signinEmailField"
                                },
                                model: {
                                  value: _vm.emailsInstrumento,
                                  callback: function($$v) {
                                    _vm.emailsInstrumento = $$v
                                  },
                                  expression: "emailsInstrumento"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-card-subtitle", [
                            _vm._v(
                              "Digite o e-mail onde deseja receber os Instrumentos de Protesto. Caso deseje receber em mais de um e-mail, favor, preenchê-los separando por vírgula."
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                disabled: !_vm.emailValido,
                                "data-cy": "enviarEmailsInstrumentos"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.baixarInstrumentos()
                                }
                              }
                            },
                            [
                              _vm._v(" Enviar "),
                              _c("v-icon", { staticClass: "ml-1" }, [
                                _vm._v("chevron_right")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.snackbar
            ? _c("Snackbar", {
                attrs: {
                  mostrarSnackbar: _vm.snackbar,
                  corSnackbar: _vm.snackbarColor,
                  mensagemSnackbar: _vm.mensagemRetornoSnackbar
                },
                on: {
                  fecharSnackbar: function($event) {
                    _vm.snackbar = false
                  }
                }
              })
            : _vm._e(),
          _c("v-data-table", {
            staticClass: "elevation-1 pa-3",
            attrs: {
              headers: _vm.headers,
              items: _vm.titulos,
              "item-text": "titulo",
              options: _vm.options,
              loading: _vm.loading,
              "single-select": false,
              "item-key": "id_titulo",
              "show-select": "",
              "footer-props": {
                itemsPerPageOptions: [50, 1000, 5000, -1],
                itemsPerPageText: "Itens por página:"
              },
              "server-items-length": _vm.totalTitulos,
              "loading-text": "Pesquisando títulos...",
              "no-data-text": "Preencha os filtros e clique em filtrar...",
              "no-results-text": "Nenhum título encontrado..."
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.ds_nosso_numero`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != ""
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(item.ds_nosso_numero))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.ds_nosso_numero))
                          ])
                    ]
                  }
                },
                {
                  key: `item.nu_identificacao_devedor`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != ""
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(_vm.formatDocumento(item)))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(_vm.formatDocumento(item)))
                          ])
                    ]
                  }
                },
                {
                  key: `item.nm_devedor`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != ""
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(item.nm_devedor))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.nm_devedor))
                          ])
                    ]
                  }
                },
                {
                  key: `item.cd_status`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != ""
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(_vm.getDescSituacao(item)))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(_vm.getDescSituacao(item)))
                          ])
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.selecionados,
              callback: function($$v) {
                _vm.selecionados = $$v
              },
              expression: "selecionados"
            }
          }),
          _c(
            "v-card",
            { staticClass: "mt-3" },
            [
              _c(
                "v-row",
                { staticClass: "ma-0" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-end pr-9",
                      attrs: { sm: "6", md: "3", lg: "4" }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            disabled: _vm.selecionados.length !== 0
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function({ on }) {
                                return [
                                  _c(
                                    "div",
                                    _vm._g({}, on),
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "intersect",
                                              rawName: "v-intersect",
                                              value: _vm.onIntersect,
                                              expression: "onIntersect"
                                            }
                                          ],
                                          staticClass: "d-flex justify-center",
                                          attrs: {
                                            color: "green white--text",
                                            disabled: !_vm.selecionados.length
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.modalEmail = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(" Baixar Instrumentos "),
                                          _c(
                                            "v-icon",
                                            { staticClass: "ml-2" },
                                            [_vm._v("mdi-chevron-right")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Selecione um ou mais títulos para liberar o comando"
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }